export default "__VITE_PUBLIC_ASSET__08c0c8a5__"